import { Box, Button, Typography } from '@material-ui/core';
import HealingIcon from '@material-ui/icons/Healing';
import CallMergeIcon from '@material-ui/icons/CallMerge';
import type { TestRun } from '../../interfaces/ui';
import TestExecutionActionDropdown from '../../common/TestExecutionActionDropdown';
import type {
  TestExecutionActionKey,
  TestExecutionActionOption,
} from '../../utils/projectExecutionActions';

interface TestRunSummaryProps {
  currentVersion: TestRun | null;
  actionOptions: TestExecutionActionOption[];
  actionDisabled: boolean;
  onActionSelect: (action: TestExecutionActionKey) => void;
}

export default function TestRunSummary({
  currentVersion,
  actionOptions,
  actionDisabled,
  onActionSelect,
}: TestRunSummaryProps) {
  if (!currentVersion) return null;

  return (
    <Box>
      <Box className="pd-summary-header">
        <Typography
          variant="h6"
          className="pd-section-title"
          style={{ margin: 0 }}
        >
          Latest run summary
        </Typography>
        <Box className="pd-run-actions">
          <TestExecutionActionDropdown
            buttonClassName="pd-run-action-btn pd-action-dropdown-trigger"
            menuClassName="pd-action-dropdown-menu"
            menuItemClassName="pd-action-dropdown-item"
            disabled={actionDisabled}
            options={actionOptions}
            onSelect={onActionSelect}
          />
          <Button
            variant="outlined"
            className="pd-run-action-btn"
            color="primary"
            startIcon={<HealingIcon />}
          >
            Heal failed tests
          </Button>
          <Button
            variant="outlined"
            color="primary"
            className="pd-run-action-btn"
            startIcon={<CallMergeIcon />}
          >
            Deduplicate tests
          </Button>
        </Box>
      </Box>

      <Box className="pd-metrics-grid">
        <Box className="pd-metric-card">
          <Typography
            component="span"
            variant="body2"
            className="pd-metric-label"
          >
            Run id
          </Typography>
          <Typography component="span" className="pd-metric-value">
            {currentVersion.transactionId}
          </Typography>
        </Box>
        {currentVersion && (
          <Box className="pd-metric-card">
            <Typography component="span" className="pd-metric-label">
              Last run
            </Typography>
            <Typography component="span" className="pd-metric-value">
              {currentVersion.createdAt?.toLocaleDateString()}
            </Typography>
          </Box>
        )}
        <Box className="pd-metric-card">
          <Typography component="span" className="pd-metric-label">
            Test cases
          </Typography>
          <Typography component="span" className="pd-metric-value">
            {currentVersion?.testCases}
          </Typography>
        </Box>
        <Box className="pd-metric-card">
          <Typography component="span" className="pd-metric-label">
            Pass rate
          </Typography>
          <Typography
            component="span"
            className="pd-metric-value pd-metric-passed"
          >
            {currentVersion?.passRate}%
          </Typography>
        </Box>
        <Box className="pd-metric-card">
          <Typography component="span" className="pd-metric-label">
            Failed
          </Typography>
          <Typography
            component="span"
            className="pd-metric-value pd-metric-failed"
          >
            {currentVersion?.failed}
          </Typography>
        </Box>
        <Box className="pd-metric-card">
          <Typography component="span" className="pd-metric-label">
            Duplicates
          </Typography>
          <Typography
            component="span"
            className="pd-metric-value pd-metric-warning"
          >
            {currentVersion?.duplicates ?? '__'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
